import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ViewReasonComponent } from 'src/app/admin/components/view-reason/view-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-social-impact-page',
  templateUrl: './social-impact-page.component.html',
  styleUrls: ['./social-impact-page.component.css'],
})
export class SocialImpactPageComponent implements OnInit {
  settingsForm: FormGroup;
  private saveApi = environment.url + environment.socialSave;
  private getApi = environment.url + environment.socialGet;
  /**
   * Component for the Social Impact page of the TBI Admin panel
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    /**
     * Form with the settings for the Social Impact page
     */
    this.settingsForm = this.fb.group({
      // question 001: Women Led Startups
      womenLedStartupsIncCentre: ['Yes'],
      womenLedStartupsDocuments: new FormArray([]),
      womenledStartupFoundersPercent: [''],
      womenledStartupFoundersCount: [''],
      womenLedStartupsImagefile: [''],
      womenLedStartupsStatus: [''],

      // question 002: SC/ST Founders
      scstFoundersIncCentre: [''],
      scstFoundersDocuments: new FormArray([]),
      scstFoundersImagefile: [''],
      scstStartupFoundersCount: [''],
      scstFoundersStatus: [''],

      // question 003: Environmental Sustainability
      environmentalSustainabilityIncCentre: [''],
      environmentalSustainabilityDocuments: new FormArray([]),
      environmentalSustainabilityImagefile: [''],
      environmentalSustainabilityNoOfStartup: [''],
      environmentalSustainabilityStatus: [''],

      // question 004: Rural and Rural Entrepreneurs
      ruralandRuralEntrepreneursIncCentre: [''],
      ruralandRuralEntrepreneursDocuments: new FormArray([]),
      ruralandRuralEntrepreneursImagefile: [''],
      ruralandRuralEntrepreneursNoOfInitiative: [''],
      ruralandRuralEntrepreneursStatus: [''],

      // question 005: Innovative Startups
      innovativeStartupsIncCentre: [''],
      innovativeStartupsDocuments: new FormArray([]),
      innovativeStartupsImagefile: [''],
      innovativeStartupsNoOfStartup: [''],
      innovativeStartupsStatus: [''],

      // question 006: Employment Generation
      employmentGenerationIncCentre: [''],
      employmentGenerationDocuments: new FormArray([]),
      employmentGenerationImagefile: [''],
      employmentGenerationNoOfEmploymentGeneration: [''],
      employmentGenerationStatus: [''],

      // new 3rd qus: Programs on Circular Economy
      programsOnCircularPresent: [''],
      programsOnCircularDocuments: new FormArray([]),
      programsOnCircularImagefile: [''],
      programsOnCircularNoOfPrograms: [''],
      programsOnCircularStatus: [''],

      // new 005 qus: Fund Facilitated for Startup
      fundFacilitatedForStartupPresent: [''],
      fundFacilitatedForStartupDocuments: new FormArray([]),
      fundFacilitatedForStartupImagefile: [''],
      fundFacilitatedForStartupNoOfStartup: [''],
      fundFacilitatedForStartupStatus: [''],

      // new 006 qus: Incubates SC/ST Center
      incubatesScStCentre: [''],
      incubatesScStDocuments: new FormArray([]),
      incubatesScStImagefile: [''],
      incubatesScStNoOfStartup: [''],
      incubatesScStStatus: [''],
    });
    /**
     * Mobile query listener
     */
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  get setting() {
    return this.settingsForm.controls;
  }
  /**
   * This method is called when the component is initialized.
   * It calls the `getPush` method to get the push notification permission,
   * the `getDataApi` method to get the data from the API,
   * and the `guidelineDatas` method to get the guideline data from the API.
   */
  ngOnInit(): void {
    this.getPush();
    this.getDataApi();
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches data from the API and updates the settings form and UI accordingly.
   * Shows a loading indicator during the request and processes the received data.
   * Patches the form with the received data and handles document uploads.
   * Updates the UI elements to reflect the status of the data and documents.
   */
  getDataApi() {
    // Show loading indicator
    this.getdata.amizhthLoader('show');

    // Make API call to fetch data
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        // Hide loading indicator after receiving data
        this.getdata.amizhthLoader('hide');
        this.getValue = data;

        // Check if the API response is successful
        if (data.responseStatus != 'Failed') {
          // Update settings form with received data
          this.settingsForm.patchValue(data);

          // Handle options based on data attributes
          this.handleOptions(data);

          // Handle document uploads
          this.handleDocuments(data);

          // Update form with new values
          this.settingsForm.patchValue(this.settingsForm.value);
          this.getdata.amizhthLoader('hide');
        }
      });
  }

  /**
   * Handles the display options based on the data attributes.
   * @param data - The data received from the API.
   */
  private handleOptions(data: any) {
    if (data.womenLedStartupsIncCentre == 'Yes') {
      this.showOptionsone('Yes', '.upload0', 0, '.set-succ0');
    }
    if (data.scstFoundersIncCentre == 'Yes') {
      this.showOptionstwo('Yes', '.upload1', 1, '.set-succ1');
    }
    if (data.environmentalSustainabilityIncCentre == 'Yes') {
      this.showOptionsthree('Yes', '.upload2', 2, '.set-succ2');
    }
    if (data.ruralandRuralEntrepreneursIncCentre == 'Yes') {
      this.showOptionsfour('Yes', '.upload3', 3, '.set-succ3');
    }
    if (data.innovativeStartupsIncCentre == 'Yes') {
      this.showOptionsfive('Yes', '.upload4', 4, '.set-succ4');
    }
    if (data.employmentGenerationIncCentre == 'Yes') {
      this.showOptionssix('Yes', '.upload5', 5, '.set-succ5');
    }
    if (data.programsOnCircularPresent == 'Yes') {
      this.showOptions11('Yes', '.upload9', 9, '.set-succ9');
    }
    if (data.fundFacilitatedForStartupPresent == 'Yes') {
      this.showOptions12('Yes', '.upload10', 10, '.set-succ10');
    }
    if (data.incubatesScStCentre == 'Yes') {
      this.showOptions13('Yes', '.upload11', 11, '.set-succ11');
    }
  }

  /**
   * Handles the document uploads and updates the UI accordingly.
   * It iterates over the list of document mappings and populates the
   * `documentValues` array with the received documents. It also updates the
   * form with the received document values and shows the upload success
   * message.
   * @param data - The data received from the API.
   */
  private handleDocuments(data: any) {
    const getform = this.settingsForm.value;

    const documentMappings = [
      {
        // question 001: Women Led Startups
        dataKey: 'womenLedStartupsDocuments',
        index: 0,
        formKey: 'womenLedStartupsImagefile',
        successClass: '.set-succ0',
        uploadWrapper: '.upload0',
      },
      {
        // question 002: SC/ST Founders
        dataKey: 'scstFoundersDocuments',
        index: 1,
        formKey: 'scstFoundersImagefile',
        successClass: '.set-succ1',
        uploadWrapper: '.upload1',
      },
      {
        // question 003: Environmental Sustainability
        dataKey: 'environmentalSustainabilityDocuments',
        index: 2,
        formKey: 'environmentalSustainabilityImagefile',
        successClass: '.set-succ2',
        uploadWrapper: '.upload2',
      },
      {
        // question 004: Rural and Rural Entrepreneurs
        dataKey: 'ruralandRuralEntrepreneursDocuments',
        index: 3,
        formKey: 'ruralandRuralEntrepreneursImagefile',
        successClass: '.set-succ3',
        uploadWrapper: '.upload3',
      },
      {
        // question 005: Innovative Startups
        dataKey: 'innovativeStartupsDocuments',
        index: 4,
        formKey: 'innovativeStartupsImagefile',
        successClass: '.set-succ4',
        uploadWrapper: '.upload4',
      },
      {
        // question 006: Employment Generation
        dataKey: 'employmentGenerationDocuments',
        index: 5,
        formKey: 'employmentGenerationImagefile',
        successClass: '.set-succ5',
        uploadWrapper: '.upload5',
      },
      {
        // new 3rd qus: Programs on Circular Economy
        dataKey: 'programsOnCircularDocuments',
        index: 9,
        formKey: 'programsOnCircularImagefile',
        successClass: '.set-succ9',
        uploadWrapper: '.upload9',
      },
      {
        // new 005 qus: Fund Facilitated for Startup
        dataKey: 'fundFacilitatedForStartupDocuments',
        index: 10,
        formKey: 'fundFacilitatedForStartupImagefile',
        successClass: '.set-succ10',
        uploadWrapper: '.upload10',
      },
      {
        // new 006 qus: Incubates SC/ST Center
        dataKey: 'incubatesScStDocuments',
        index: 11,
        formKey: 'incubatesScStImagefile',
        successClass: '.set-succ11',
        uploadWrapper: '.upload11',
      },
    ];

    documentMappings.forEach((mapping) => {
      const documents = data[mapping.dataKey];
      if (documents && documents.length > 0) {
        this.documentValues[mapping.index] = documents;
        getform[mapping.formKey] = documents[0].documentFile;
        setTimeout(() => {
          // Show success message
          $(mapping.successClass).addClass('success');
          // Hide upload button
          $(`.upload-wrapper${mapping.uploadWrapper}`).addClass('d-none');
          // Hide upload success message
          $(`.upload-wrapper${mapping.uploadWrapper}`).removeClass('success');
          // Show remove button
          $(`.remove-wrapper${mapping.uploadWrapper}`).addClass(
            'd-flex active'
          );
        }, 5000);
      }
    });
  }
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Opens a dialog to display the reason for the given status.
   * @param status - The status object or value to show the reason for.
   */
  viewReasonBtn(status: any) {
    const dialogRef = this.dialog.open(ViewReasonComponent, {
      width: '390px',
      data: { _status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // No action needed after the dialog is closed.
    });
  }
  /**
   * Sets the value of the specified form control in the settings form.
   * @param event - The event that triggered this function (not used).
   * @param key - The name of the form control to update.
   * @param value - The value to set the form control to.
   */
  setStatus(event, key: string, value: any): void {
    this.settingsForm.controls[key].setValue(value);
  }
  /**
   * Adds 12 new document request objects to the `documentValues` array.
   * Each object contains empty `documentName` and `documentFile` fields.
   */
  getPush() {
    for (let i = 0; i < 12; i++) {
      // Create a new document request object with empty fields
      let req = [
        {
          documentName: '',
          documentFile: '',
        },
      ];
      // Add the object to the documentValues array
      this.documentValues.push(req);
    }
  }
  selecetdFile: any = [];
  url: any;
  ImageValue: any = '';
  ImageType: any;
  documentValues = [];
  /**
   * Handles the file upload event for the specified document request object.
   * @param event - The event that triggered this function.
   * @param val - The value of the document request object.
   * @param i - The index of the document request object in the `documentValues` array.
   * @param set - The class selector for the div containing the upload button.
   */
  fileUpload(event, val, i, set) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Check if the uploaded file is an image with the allowed extensions
      if (
        img_crt_type === 'jpeg' ||
        img_crt_type === 'jpg' ||
        img_crt_type === 'png' ||
        img_crt_type === 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          let val = this.documentValues[i];
          val[0].documentFile = spl[1];
          val[0].documentName = this.selecetdFile.name;
          this.documentValues[i] = val;

          // Set the value of the corresponding form control
          switch (i) {
            case 0:
              this.settingsForm.controls['womenLedStartupsStatus'].setValue(7);
              this.settingsForm.controls['womenLedStartupsImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 1:
              this.settingsForm.controls['scstFoundersStatus'].setValue(7);
              this.settingsForm.controls['scstFoundersImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 2:
              this.settingsForm.controls[
                'environmentalSustainabilityStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'environmentalSustainabilityImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 3:
              this.settingsForm.controls[
                'ruralandRuralEntrepreneursStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'ruralandRuralEntrepreneursImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 4:
              this.settingsForm.controls['innovativeStartupsStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'innovativeStartupsImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 5:
              this.settingsForm.controls['employmentGenerationStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'employmentGenerationImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            // new 3rd qus
            case 9:
              this.settingsForm.controls['programsOnCircularStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'programsOnCircularImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            // new 5rd qus
            case 10:
              this.settingsForm.controls[
                'fundFacilitatedForStartupStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'fundFacilitatedForStartupImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            // new 6rd qus
            case 11:
              this.settingsForm.controls['incubatesScStStatus'].setValue(7);
              this.settingsForm.controls['incubatesScStImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
          }

          // Add animations to the upload button
          setTimeout(function () {
            let datass = '.upload-wrapper' + val;
            $(datass).addClass('uploaded');
          }, 600);
          setTimeout(function () {
            let datas = '.upload-wrapper' + val;
            $(datas).removeClass('uploaded');
            $(datas).addClass('success');
            $(set).addClass('success');
          }, 1600);
          setTimeout(function () {
            let datas = '.upload-wrapper' + val;
            $(datas).addClass('d-none');
            $(datas).removeClass('success');
            let data = '.remove-wrapper' + val;
            $(data).addClass('d-flex');
            $(data).addClass('active');
          }, 5000);
        };
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png formet images are allowed'
        );
      }
    }
  }
  /**
   * Handles the removal of a file from the upload controls.
   * Resets the form controls and removes the file from the server.
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  removeFile(val, i, set) {
    // Reset the form controls to their initial state
    this.documentValues[i][0].documentFile = '';
    this.documentValues[i][0].documentName = '';

    // Remove the file from the server
    setTimeout(function () {
      // Remove the file upload button wrapper
      let datass = '.upload-wrapper' + val;
      $(datass).removeClass('d-none');

      // Remove the file remove button wrapper
      let data = '.remove-wrapper' + val;
      $(data).removeClass('d-flex');
      $(data).removeClass('active');

      // Remove the success indicator
      $(set).removeClass('success');
    }, 1000);

    // Update the form controls based on the index
    switch (i) {
      case 0:
        this.settingsForm.controls['womenLedStartupsStatus'].setValue(1);
        this.settingsForm.controls['womenLedStartupsImagefile'].setValue('');
        break;
      case 1:
        this.settingsForm.controls['scstFoundersStatus'].setValue(1);
        this.settingsForm.controls['scstFoundersImagefile'].setValue('');
        break;
      case 2:
        this.settingsForm.controls[
          'environmentalSustainabilityStatus'
        ].setValue(1);
        this.settingsForm.controls[
          'environmentalSustainabilityImagefile'
        ].setValue('');
        break;
      case 3:
        this.settingsForm.controls['ruralandRuralEntrepreneursStatus'].setValue(
          1
        );
        this.settingsForm.controls[
          'ruralandRuralEntrepreneursImagefile'
        ].setValue('');
        break;
      case 4:
        this.settingsForm.controls['innovativeStartupsStatus'].setValue(1);
        this.settingsForm.controls['innovativeStartupsImagefile'].setValue('');
        break;
      case 5:
        this.settingsForm.controls['employmentGenerationStatus'].setValue(1);
        this.settingsForm.controls['employmentGenerationImagefile'].setValue(
          ''
        );
        break;
      // new 3rd qus
      case 9:
        this.settingsForm.controls['programsOnCircularStatus'].setValue(1);
        this.settingsForm.controls['programsOnCircularImagefile'].setValue('');
        break;
      // new 5rd qus
      case 10:
        this.settingsForm.controls['fundFacilitatedForStartupStatus'].setValue(
          1
        );
        this.settingsForm.controls[
          'fundFacilitatedForStartupImagefile'
        ].setValue('');
        break;
      // new 6rd qus
      case 11:
        this.settingsForm.controls['incubatesScStStatus'].setValue(1);
        this.settingsForm.controls['incubatesScStImagefile'].setValue('');
        break;
    }
  }
  Optionsonechecked = '';
  /**
   * Handles the change event for the women-led startup founders option.
   * Updates form controls based on the selected option.
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionsone(event, val, i, set) {
    // Update the checked status of the option
    this.Optionsonechecked = event;

    // If the user selected 'No', clear the form controls
    if (event == 'No') {
      // Remove the file if it exists
      this.removeFile(val, i, set);
      // Clear the validators and values of the form controls
      this.settingsForm.controls['womenledStartupFoundersCount'].setValue(0);
      this.settingsForm.controls[
        'womenledStartupFoundersCount'
      ].clearValidators();
      this.settingsForm.controls['womenledStartupFoundersPercent'].setValue(0);
      this.settingsForm.controls[
        'womenledStartupFoundersPercent'
      ].clearValidators();
      this.settingsForm.controls['womenLedStartupsImagefile'].setValue('');
      this.settingsForm.controls['womenLedStartupsImagefile'].clearValidators();
    } else {
      // If the user selected 'Yes', set the validators of the form controls
      this.settingsForm.controls['womenledStartupFoundersCount'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls[
        'womenledStartupFoundersPercent'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['womenLedStartupsImagefile'].setValidators([
        Validators.required,
      ]);
    }

    // Update the validity of the form controls
    this.settingsForm.controls[
      'womenledStartupFoundersCount'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'womenledStartupFoundersPercent'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'womenLedStartupsImagefile'
    ].updateValueAndValidity();
  }
  Optionstwochecked = '';
  /**
   * Handles the change event for the SC/ST startup founders option.
   * Updates form controls based on the selected option.
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionstwo(event, val, i, set) {
    this.Optionstwochecked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      // Clear the scstStartupFoundersCount value and validators
      this.settingsForm.controls['scstStartupFoundersCount'].setValue(0);
      this.settingsForm.controls['scstStartupFoundersCount'].clearValidators();
      // Clear the scstFoundersImagefile value and validators
      this.settingsForm.controls['scstFoundersImagefile'].setValue('');
      this.settingsForm.controls['scstFoundersImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for scstStartupFoundersCount and scstFoundersImagefile controls
      this.settingsForm.controls['scstStartupFoundersCount'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['scstFoundersImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the scstStartupFoundersCount and scstFoundersImagefile controls
    this.settingsForm.controls[
      'scstStartupFoundersCount'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'scstFoundersImagefile'
    ].updateValueAndValidity();
  }
  Optionsthreechecked = '';
  /**
   * Handles the change event for the environmental sustainability option.
   * Updates form controls based on the selected option.
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionsthree(event, val, i, set) {
    this.Optionsthreechecked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      // Clear the environmentalSustainabilityNoOfStartup value and validators
      this.settingsForm.controls[
        'environmentalSustainabilityNoOfStartup'
      ].setValue(0);
      this.settingsForm.controls[
        'environmentalSustainabilityNoOfStartup'
      ].clearValidators();
      // Clear the environmentalSustainabilityImagefile value and validators
      this.settingsForm.controls[
        'environmentalSustainabilityImagefile'
      ].setValue('');
      this.settingsForm.controls[
        'environmentalSustainabilityImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for environmentalSustainabilityNoOfStartup and environmentalSustainabilityImagefile controls
      this.settingsForm.controls[
        'environmentalSustainabilityNoOfStartup'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'environmentalSustainabilityImagefile'
      ].setValidators([Validators.required]);
    }
    // Update the validity of the environmentalSustainabilityNoOfStartup and environmentalSustainabilityImagefile controls
    this.settingsForm.controls[
      'environmentalSustainabilityNoOfStartup'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'environmentalSustainabilityImagefile'
    ].updateValueAndValidity();
  }
  Optionsfourchecked = '';
  /**
   * Handles the change event for the rural and rural entrepreneurs option.
   * Updates form controls based on the selected option.
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionsfour(event, val, i, set) {
    // Store the selected option
    this.Optionsfourchecked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      this.removeFile(val, i, set);
      // Clear the number of initiatives and image file values and validators
      this.settingsForm.controls[
        'ruralandRuralEntrepreneursNoOfInitiative'
      ].setValue(0);
      this.settingsForm.controls[
        'ruralandRuralEntrepreneursNoOfInitiative'
      ].clearValidators();
      this.settingsForm.controls[
        'ruralandRuralEntrepreneursImagefile'
      ].setValue('');
      this.settingsForm.controls[
        'ruralandRuralEntrepreneursImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for the number of initiatives and image file controls
      this.settingsForm.controls[
        'ruralandRuralEntrepreneursNoOfInitiative'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'ruralandRuralEntrepreneursImagefile'
      ].setValidators([Validators.required]);
    }

    // Update the validity of the form controls
    this.settingsForm.controls[
      'ruralandRuralEntrepreneursNoOfInitiative'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'ruralandRuralEntrepreneursImagefile'
    ].updateValueAndValidity();
  }
  Optionsfivechecked = '';
  /**
   * Show/hide form controls based on the 'Innovative Startups' radio button selection.
   * @param event The selected value of the radio button.
   * @param val The value to be used to set the form controls.
   * @param i The index of the form control.
   * @param set The suffix to be added to the form control name.
   */
  showOptionsfive(event, val, i, set) {
    this.Optionsfivechecked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      this.removeFile(val, i, set);
      // Clear the number of innovative startups and image file values and validators
      this.settingsForm.controls['innovativeStartupsNoOfStartup'].setValue(0);
      this.settingsForm.controls[
        'innovativeStartupsNoOfStartup'
      ].clearValidators();
      this.settingsForm.controls['innovativeStartupsImagefile'].setValue('');
      this.settingsForm.controls[
        'innovativeStartupsImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for the number of innovative startups and image file controls
      this.settingsForm.controls['innovativeStartupsNoOfStartup'].setValidators(
        [Validators.required]
      );
      this.settingsForm.controls['innovativeStartupsImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'innovativeStartupsNoOfStartup'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'innovativeStartupsImagefile'
    ].updateValueAndValidity();
  }
  Optionssixchecked = '';
  /**
   * Handles the change event for the 'employment generation' option.
   * Updates form controls based on the selected option.
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptionssix(event, val, i, set) {
    this.Optionssixchecked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      this.removeFile(val, i, set);
      // Clear the employmentGenerationNoOfEmploymentGeneration and image file values and validators
      this.settingsForm.controls[
        'employmentGenerationNoOfEmploymentGeneration'
      ].setValue(0);
      this.settingsForm.controls[
        'employmentGenerationNoOfEmploymentGeneration'
      ].clearValidators();
      this.settingsForm.controls['employmentGenerationImagefile'].setValue('');
      this.settingsForm.controls[
        'employmentGenerationImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for the employmentGenerationNoOfEmploymentGeneration and image file controls
      this.settingsForm.controls[
        'employmentGenerationNoOfEmploymentGeneration'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['employmentGenerationImagefile'].setValidators(
        [Validators.required]
      );
    }
    // Update the validity of the employmentGenerationNoOfEmploymentGeneration and image file controls
    this.settingsForm.controls[
      'employmentGenerationNoOfEmploymentGeneration'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'employmentGenerationImagefile'
    ].updateValueAndValidity();
  }
  // new 3rd qus
  Options11checked = '';
  /**
   * Update form controls related to 'Programs on Circular' based on the radio button selection.
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptions11(event, val, i, set) {
    this.Options11checked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      // for programsOnCircularNoOfPrograms and programsOnCircularImagefile
      this.removeFile(val, i, set);
      // Clear the programsOnCircularNoOfPrograms and image file values and validators
      this.settingsForm.controls['programsOnCircularNoOfPrograms'].setValue(0);
      this.settingsForm.controls[
        'programsOnCircularNoOfPrograms'
      ].clearValidators();
      this.settingsForm.controls['programsOnCircularImagefile'].setValue('');
      this.settingsForm.controls[
        'programsOnCircularImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for the programsOnCircularNoOfPrograms and image file controls
      this.settingsForm.controls[
        'programsOnCircularNoOfPrograms'
      ].setValidators([Validators.required]);
      this.settingsForm.controls['programsOnCircularImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the programsOnCircularNoOfPrograms and image file controls
    this.settingsForm.controls[
      'programsOnCircularNoOfPrograms'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'programsOnCircularImagefile'
    ].updateValueAndValidity();
  }
  // new 5th qus
  Options12checked = '';
  /**
   * Updates form controls related to 'Fund Facilitated For Startup' based on the radio button selection.
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptions12(event, val, i, set) {
    this.Options12checked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      // for fundFacilitatedForStartupNoOfStartup and fundFacilitatedForStartupImagefile
      this.removeFile(val, i, set);
      // Clear the fundFacilitatedForStartupNoOfStartup and image file values and validators
      this.settingsForm.controls[
        'fundFacilitatedForStartupNoOfStartup'
      ].setValue(0);
      this.settingsForm.controls[
        'fundFacilitatedForStartupNoOfStartup'
      ].clearValidators();
      this.settingsForm.controls['fundFacilitatedForStartupImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'fundFacilitatedForStartupImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for the fundFacilitatedForStartupNoOfStartup and image file controls
      this.settingsForm.controls[
        'fundFacilitatedForStartupNoOfStartup'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'fundFacilitatedForStartupImagefile'
      ].setValidators([Validators.required]);
    }
    // Update the validity of the fundFacilitatedForStartupNoOfStartup and image file controls
    this.settingsForm.controls[
      'fundFacilitatedForStartupNoOfStartup'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'fundFacilitatedForStartupImagefile'
    ].updateValueAndValidity();
  }
  // new 6th qus
  Options13checked = '';
  /**
   * Handles the change event for the 'incubatesScSt' radio button option.
   * Updates the form controls and their validators based on the selected option.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptions13(event, val, i, set) {
    this.Options13checked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the associated file and clear validators
      // for incubatesScStNoOfStartup and incubatesScStImagefile
      this.removeFile(val, i, set);
      // Clear the incubatesScStNoOfStartup and image file values and validators
      this.settingsForm.controls['incubatesScStNoOfStartup'].setValue(0);
      this.settingsForm.controls['incubatesScStNoOfStartup'].clearValidators();
      this.settingsForm.controls['incubatesScStImagefile'].setValue('');
      this.settingsForm.controls['incubatesScStImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for the incubatesScStNoOfStartup and image file controls
      this.settingsForm.controls['incubatesScStNoOfStartup'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['incubatesScStImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the incubatesScStNoOfStartup and image file controls
    this.settingsForm.controls[
      'incubatesScStNoOfStartup'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'incubatesScStImagefile'
    ].updateValueAndValidity();
  }
  /**
   * Saves the form data.
   * If the form is invalid, shows an error notification.
   * If the form is valid, attaches document values if available, and submits the data to the API.
   * Shows notifications based on the result.
   */
  saveBtn() {
    let getform = this.settingsForm.value;

    if (this.settingsForm.invalid) {
      // If the form is invalid, show an error notification
      this.settingsForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Attach documents to the form data if available
      if (this.documentValues[0][0].documentFile != '') {
        getform.womenLedStartupsDocuments = this.documentValues[0];
      }
      if (this.documentValues[1][0].documentFile != '') {
        getform.scstFoundersDocuments = this.documentValues[1];
      }
      if (this.documentValues[2][0].documentFile != '') {
        getform.environmentalSustainabilityDocuments = this.documentValues[2];
      }
      if (this.documentValues[3][0].documentFile != '') {
        getform.ruralandRuralEntrepreneursDocuments = this.documentValues[3];
      }
      if (this.documentValues[4][0].documentFile != '') {
        getform.innovativeStartupsDocuments = this.documentValues[4];
      }
      if (this.documentValues[5][0].documentFile != '') {
        getform.employmentGenerationDocuments = this.documentValues[5];
      }
      // new 3rd qus
      if (this.documentValues[9][0].documentFile != '') {
        getform.programsOnCircularDocuments = this.documentValues[9];
      }
      // new 5rd qus
      if (this.documentValues[10][0].documentFile != '') {
        getform.fundFacilitatedForStartupDocuments = this.documentValues[10];
      }
      // new 6th qus
      if (this.documentValues[11][0].documentFile != '') {
        getform.incubatesScStDocuments = this.documentValues[11];
      }
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          // Increment the step value if the API call is successful
          this.step++;
          // Call the getDataApi method to fetch the data again
          this.getDataApi();
          this.notify.notifysuccess(data.responseMessage);
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[6].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.saveBtn();
  }
  prevStep() {
    this.step--;
  }
}
